// Test IDs for AccessVerse features
export const ACCESS_VERSE = {
  quoteRequestBtn: 'quote-request-btn',
  bookConsultationBtn: 'book-consultation-btn',
  floatingA11yPanelToggle: 'a11y-panel-toggle',
  a11yContrastToggle: 'a11y-contrast-toggle',
  a11yTextIncrease: 'a11y-text-increase',
  a11yTextDecrease: 'a11y-text-decrease',
  a11yTextReset: 'a11y-text-reset',
  a11yScreenReaderToggle: 'a11y-screen-reader-toggle',
  a11yDyslexiaToggle: 'a11y-dyslexia-toggle',
  a11yOutlineFocusToggle: 'a11y-outline-focus-toggle',
  
  quoteFormName: 'quote-form-name',
  quoteFormEmail: 'quote-form-email',
  quoteFormCompany: 'quote-form-company',
  quoteFormWebsite: 'quote-form-website',
  quoteFormServices: 'quote-form-services',
  quoteFormPages: 'quote-form-pages',
  quoteFormDetails: 'quote-form-details',
  quoteFormSubmit: 'quote-form-submit',
  
  consultFormName: 'consult-form-name',
  consultFormEmail: 'consult-form-email',
  consultFormCompany: 'consult-form-company',
  consultFormDate: 'consult-form-date',
  consultFormTime: 'consult-form-time',
  consultFormNeeds: 'consult-form-needs',
  consultFormSubmit: 'consult-form-submit',

  sliderToggle: 'slider-toggle-mode',
  sliderHandle: 'slider-handle',
  
  adminDashboardTab: 'nav-admin-dashboard-tab',
  designSystemTab: 'nav-design-system-tab',
  homepageTab: 'nav-homepage-tab',
};
